import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RotaProtegida({ children, perfis }) {
    const { usuario } = useAuth();

    if (!usuario) return <Navigate to="/login" />;
    if (perfis && !perfis.includes(usuario.perfil)) return <Navigate to="/" />;

    return children;
}